<template>
	<div class="customers-picker">
		<AppBottomSheet :active="active" :forceWidth="bottomSheetWidth" @toggling-popup="open => $emit('toggling-popup', open)" >
			<div class="customers-picker-content" v-if="active">
				<div class="header-actions">
					<h3>{{ people ? getString('people') : getString('companies') }}</h3>
					<AppSwitch v-show="!peopleOnly && !companiesOnly" ref="customer-type-switch" left-icon="iconPerson" right-icon="iconCompany" fixed-color @switched="switchTable" ></AppSwitch>
				</div>
				<AppTable
					v-if="people || peopleOnly"
					ref="people-table"
					:filters="filtersPeople"
					:fetch-function="fetchFunctionPeople"
					:table-headings="tableHeadingsPeople"
					:total-items="customersStore.customersPeopleTotal"
					:items="customersToShow" >
					<template #before-table>
						<div class="row align-center space-between row-actions mb-10">
							<div class="left-column">
								<AppButton icon-left="icon-plus" small outline :text="getString('add_customer')" @click="newPersonSheet = true" />
							</div>
							<div class="right-column">
								<AppTextInput ref="search-input" icon-name="icon-magnify" :placeholder="getString('search')" @changed-text="v => searchPeople = v" />
							</div>
						</div>
					</template>
					<template #settingsIcon="{item, heading}">
						<AppTableButtonGroup :buttons="buttonsPerson" @picked-customer="pickedCustomer(item, 'person')"/>
					</template>
				</AppTable>
				<AppTable
					v-else
					ref="companies-table"
					:filters="filtersCompanies"
					:fetch-function="fetchFunctionCompanies"
					:table-headings="tableHeadingsCompanies"
					:total-items="customersStore.customersCompaniesTotal"
					:items="companiesToShow"
					initial-sort-field="debit"
				>
					<template #before-table>
						<div class="row align-center space-between row-actions mb-10">
							<div class="left-column">
								<AppButton icon-left="icon-plus" small outline :text="getString('add_company')" @click="newCompanySheet = true" />
							</div>
							<div class="right-column">
								<AppTextInput ref="search-input" icon-name="icon-magnify" :placeholder="getString('search')" @changed-text="v => searchCompanies = v" />
							</div>
						</div>
					</template>
					<template #settingsIcon="{item, heading}">
						<AppTableButtonGroup :buttons="buttonsCompany" @picked-customer="pickedCustomer(item, 'company')"/>
					</template>
				</AppTable>
			</div>
		</AppBottomSheet>
		<CustomersPeopleAdd :active="newPersonSheet" show-button-existing @close="personAddClose" @toggling-popup="togglingPopupPerson" @added-customer="addedCustomer" />
		<CustomersCompanyAdd :active="newCompanySheet" show-button-existing @close="companyAddClose" @toggling-popup="togglingPopupCompany" @added-customer="addedCompany" />
	</div>
</template>

<script>
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppTable from "@/shared/components/AppTable.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppTableButton from "@/shared/components/AppTableButton.vue";
import AppTableButtonGroup from "@/shared/components/AppTableButtonGroup.vue";
import {useCurrencyStore, useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useCustomersStore, useUserStore} from "@/console-new/stores";
import {formatDateYYMMDD} from "@/shared/helpers/dates";
import CustomersPeopleAdd from "@/console-new/components/ops/CustomersPeopleAdd.vue";
import CustomersCompanyAdd from "@/console-new/components/ops/CustomersCompanyAdd.vue";
import AppSwitch from "@/shared/components/AppSwitch.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		const customersStore = useCustomersStore();
		const currencyStore = useCurrencyStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, userStore, currencyStore, customersStore, formatDateYYMMDD}
	},
	name: "CustomersPicker",
	components: {AppSwitch, CustomersCompanyAdd, CustomersPeopleAdd, AppButtonIcon, AppButton, AppTable, AppTextInput, AppBottomSheet, AppTableButton, AppTableButtonGroup},
	emits: ['toggling-popup', 'picked-customer'],
	mixins: [WindowWidth],
	data() {
		return {
			people: true,
			filtersPeople: [
				{
					type: "price",
					key: "debit",
					text: this.getString("debit"),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
			],
			tableHeadingsPeople: [
				{
					text: this.getString('name'),
					cols: 2,
					sortable: true,
					fieldName: 'name',
				},
				{
					text: this.getString('debit'),
					cols: 1,
					fieldName: 'readable_debit',
				},
				{
					text: this.getString('credit'),
					cols: 1,
					fieldName: 'readable_credit',
				},
				{
					text: this.getString('choose'),
					cols: 1,
					fieldName: 'settings',
					slotName: 'settingsIcon',
				},
				{
					text: this.getString('email'),
					cols: 2,
					fieldName: 'email',
					formatter: v => v || '-',
				},
			],
			filtersCompanies: [
				{
					type: "price",
					key: "debit",
					text: this.getString("debit"),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
			],
			tableHeadingsCompanies: [
				{
					text: this.getString('fiscal_name'),
					cols: 2,
					sortable: true,
					fieldName: 'name',
				},
				{
					text: this.getString('debit'),
					cols: 1,
					fieldName: 'readable_debit',
				},
				{
					text: this.getString('credit'),
					cols: 1,
					fieldName: 'readable_credit',
				},
				{
					text: this.getString('choose'),
					cols: 1,
					fieldName: 'settings',
					slotName: 'settingsIcon',
				},
				{
					text: this.getString('vat_cf'),
					cols: 1,
					fieldName: 'vat_cf_fallback',
				},
			],
			searchPeople: null,
			searchCompanies: null,
			newPersonSheet: false,
			newCompanySheet: false,
		}
	},
	props: {
		peopleOnly: {
			type: Boolean,
			default: false,
		},
		companiesOnly: {
			type: Boolean,
			default: false,
		},
		active: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		buttonsCompany() {
			return [
				{
					iconName: "icon-select-blue",
					emitName: "picked-customer",
				},
			];
		},
		buttonsPerson() {
			return [
				{
					iconName: "icon-select-blue",
					emitName: "picked-customer",
				},
			];
		},
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		customersToShow() {
			return this.customersStore.customersPeople.map(customer => {
				return {
					...customer,
					readable_debit: this.currencyStore.readableCurrencyValue(customer.debit),
					readable_credit: this.currencyStore.readableCurrencyValue(customer.credit),
				}
			});
		},
		companiesToShow() {
			return this.customersStore.customersCompanies.map(customer => {
				return {
					...customer,
					readable_debit: this.currencyStore.readableCurrencyValue(customer.debit),
					readable_credit: this.currencyStore.readableCurrencyValue(customer.credit),
				}
			});
		},
	},
	methods: {
		fetchFunctionPeople(filters, callback) {
			if (this.searchPeople && this.searchPeople.length > 2) {
				filters.name = "%" + this.searchPeople + "%";
			}
			return this.customersStore.getFilteredPeople(filters, callback);
		},
		fetchFunctionCompanies(filters, callback) {
			if(this.searchCompanies && this.searchCompanies.length > 2) {
				filters.name = "%" + this.searchCompanies + "%";
			}
			return this.customersStore.getFilteredCompanies(filters, callback);
		},
		pickedCustomer(customer, type) {
			this.$emit('picked-customer', {
				...customer,
				type,
			});
		},
		togglingPopupPerson(isOpen) {
			if(!isOpen) {
				this.newPersonSheet = false;
			}
		},
		togglingPopupCompany(isOpen) {
			if(!isOpen) {
				this.newCompanySheet = false;
			}
		},
		addedCustomer(customer) {
			this.newPersonSheet = false;
			this.pickedCustomer(customer, 'person');
		},
		addedCompany(customer) {
			this.newCompanySheet = false;
			this.pickedCustomer(customer, 'company');
		},
		switchTable() {
			this.people = !this.people;
			this.searchPeople = null;
		},
		personAddClose() {
			this.newPersonSheet = false;
			this.$emit('person-open-picker');
		},
		companyAddClose() {
			this.newCompanySheet = false;
			this.$emit('company-open-picker');
		},
	},
	created() {
		if (this.companiesOnly) {
			this.people = false;
		}
	},
	watch: {
		searchPeople(newValue, oldValue) {
			if(newValue !== oldValue) {
				this.$refs && this.$refs['people-table'] && this.$refs['people-table'].fetchData();
			}
		},
		searchCompanies(newValue, oldValue) {
			if(newValue !== oldValue) {
				this.$refs && this.$refs['companies-table'] && this.$refs['companies-table'].fetchData();
			}
		},
		active(newValue, oldValue) {
			if(newValue !== oldValue) {
				if(newValue) {
					this.searchPeople = null;
					this.searchCompanies = null;
					if(!this.companiesOnly) {
						this.people = true;
					}
				}
			}
		},
	}
}
</script>

<style scoped lang="scss">
.row-actions {
	padding: 10px;
	gap: 8px;
	background-color: var(--color-bg-primary-2);
	border-radius: 13px 13px 0 0;

	.right-column {
		display: flex;
		align-items: center;
		margin-left: auto;
	}

	.input-wrapper {
		width: 200px;

		@media (max-width: 1050px) {
			width: 140px;
		}

		@media (max-width: 900px) {
			width: 130px;

			:deep(.input-element) {

				img {
					width: 14px;
					height: 14px;
				}

				input {
					height: 27px;
					padding-left: 32px;
				}
			}
		}

		@media (max-width: 420px) {
			width: 120px;
		}

	}
}
.customers-picker-content {
	.header-actions {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: var(--color-bg-primary-2);
		border-radius: 13px;
		padding: 10px;
		box-shadow: inset 0 1px 2px var(--color-alpha-4);
		flex-wrap: wrap;
		gap: 8px;
	}
	:deep(.table-wrapper){
		padding-top: 0;
		margin-top: 10px;
	}
	:deep(.card-header) {
		display: none;
	}
}

</style>